import { DataBean } from "../DataBean";

export class CatalogByIncomeResponsible extends DataBean {



    public async getAccountantConceptCatalogByIncomeResponsible(idAccount:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantConceptCatalogByIncomeResponsible_Number", [idAccount]);
    }
    
}